// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

export const getId = (id?: string | null): number | null => {
    if (!id) {
        return null;
    }

    return Number(atob(id).split(':')[1]);
};
